import * as React from "react";
import { NBSteppers } from "../../Resource/Contents";
import { AdviserDetail } from "./AdviserDetail";
import { ClientDetail } from "./ClientDetail";
import { ContactDetail } from "./ContactDetail";
import { TaxDetail } from "./TaxDetail";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { NewBusinessAction } from "../../Actions/NewBusinessAction";
import { setValueByKey } from "../../../../../../Shared/Table/Utils/TableUtils";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { ProcessNavigateCustomBtn } from "../../../../../../Shared/Process/Process/ProcessNavigateBtn";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../../Urls";
import { CustomerPhoneNumberType } from "../../../../../../../Wrap/Constants/Enums/Domain/CustomerPhoneNumberType";
import { TaxReferenceType } from "../../../../../../../Wrap/Constants/Enums/Customer/TaxReferenceType";
import { CountryCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import {
    AdviserContextStoreStatic,
    CustomerContextDispatcher,
    CustomerContextStoreStatic,
} from "../../Stores/Variable";
import { ActionType } from "../../../../../../../react-core/Flux/ActionType";
import { TitleMap } from "../../../../../../Shared/Entities/Maps/TitleMap";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { RoleType } from "../../../../../../../Wrap/Constants/Enums/RoleType";
import { AccountInfoAction } from "../../../PortfolioDashboard/Components/Role/Action/AccountInfoAction";
import { FullClientDetailHelper } from "../../../Common/FullClientDetail/FullClientDetailHelper";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { PhysicalAddressType } from "../../../../../../../Wrap/Constants/Enums/Customer/PhysicalAddressType";
import { GuardianDetail } from "./GuardianDetail";
import { CircleBtn, CircleBtnType } from "../../../../../../../react-core/Html/CircleBtn";

interface IFullClientDetailProps extends IProcessComponentProps {
    onChange: (changes) => void;
    onRef: (ref) => void;
    clearMsg: () => void;
    customerId?: number;
    navigateAfterSubmit: boolean;
    disableWhenFullClient: boolean;
    isAddNewProduct: boolean;
    ownerAdviserId?: number;
    data: ApplyModel;
    existingCustomer?: boolean;
}

interface IFullClientDetailState {
    model: FullClientDetailModel;
    secondmodel: FullClientDetailModel;
    AdvisorName: string;
    isLoading: boolean;
    isBusy: boolean;
    hasMobile: boolean;
    hasLandPhone: boolean;
    secondCustomerHasLandPhone: boolean;
    secondCustomerHasMobile: boolean;
    isJointAccount: boolean;
    secondCustomerId: number;
    hasCorrespondenceAddress: boolean;
    guardianmodel: FullClientDetailModel;
    guardianHasLandPhone: boolean;
    guardianHasMobile: boolean;
    addGuardianDetails: boolean;
}

export class FullClientDetail extends ProcessComponent<IFullClientDetailProps, IFullClientDetailState> {
    constructor(props: any) {
        super(props);
        this.state = {
            model: {
                EmailAddressDetails: [{ EmailAddressType: null, EmailAddress: null }],
                CustomerTaxResidencyDetails: [
                    {
                        Country: CountryCode.GBR,
                        IsTaxResident: true,
                        TaxReferenceType: TaxReferenceType.GbrNino,
                    },
                ],
                AddressDetails: [],
            },
            secondmodel: {
                EmailAddressDetails: [{ EmailAddressType: null, EmailAddress: null }],
                CustomerTaxResidencyDetails: [
                    {
                        Country: CountryCode.GBR,
                        IsTaxResident: true,
                        TaxReferenceType: TaxReferenceType.GbrNino,
                    },
                ],
                AddressDetails: [],
            },
            AdvisorName: "",
            isLoading: true,
            isBusy: false,
            hasLandPhone: false,
            hasMobile: false,
            secondCustomerHasLandPhone: false,
            secondCustomerHasMobile: false,
            isJointAccount: false,
            secondCustomerId: 0,
            hasCorrespondenceAddress: true,
            guardianmodel: {
                EmailAddressDetails: [{ EmailAddressType: null, EmailAddress: null }],
                CustomerTaxResidencyDetails: [
                    {
                        Country: CountryCode.GBR,
                        IsTaxResident: true,
                        TaxReferenceType: TaxReferenceType.GbrNino,
                    },
                ],
                AddressDetails: [],
            },
            guardianHasLandPhone: false,
            guardianHasMobile: false,
            addGuardianDetails: true,
        };
        this.subscribeToStore(AdviserContextStoreStatic, () => this.onAdviserContextStoreChange());
        this.subscribeToStore(CustomerContextStoreStatic, () => this.onCustomerContextStoreChange());
    }

    onCorrespondenceAddressChange(val): void {
        this.setState({ hasCorrespondenceAddress: val });
    }

    onCustomerContextStoreChange(): void {
        this.loadCustomerFromStore();
        this.loadAdviserFromStore();

        let initArray = [];

        //only do this when it's NBNC
        initArray = FullClientDetailHelper.initTaxModel(initArray, this.state.model);
        initArray = FullClientDetailHelper.updatePostalAddress(initArray, this.state.model);
        this.onCCMChange(initArray, false, false);
        initArray = [];

        //only do this when it's NBNC
        initArray = FullClientDetailHelper.initTaxModel(initArray, this.state.secondmodel);
        initArray = FullClientDetailHelper.updatePostalAddress(initArray, this.state.model);
        this.onCCMChange(initArray, true, false);
        initArray = [];

        initArray = FullClientDetailHelper.initTaxModel(initArray, this.state.guardianmodel);
        initArray = FullClientDetailHelper.updatePostalAddress(initArray, this.state.model);
        this.onCCMChange(initArray, false, true);

        if (!this.state.AdvisorName && this.state.model) {
            NewBusinessAction.getAdviserDetail(
                HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Advisor, this.state.model.ActorOwnerId)
            );
        }
    }

    loadSecondCustomer(customerId: number): void {
        NewBusinessAction.getFullClientDetailsForTheSecondCustomer(customerId, (result) => {
            this.setState({
                secondmodel: result,
                secondCustomerHasMobile: result.PhoneNumberDetails.some(
                    (ele) => ele.PhoneNumberType == CustomerPhoneNumberType.Mobile
                ),
                secondCustomerHasLandPhone: result.PhoneNumberDetails.some(
                    (ele) => ele.PhoneNumberType == CustomerPhoneNumberType.Home
                ),
            });
            this.props.onChange({
                SecondClientDetails: {
                    ActorId: result.ActorId,
                    FirstName: result.PersonalDetails?.GivenName,
                    LastName: result.PersonalDetails?.FamilyName,
                    Title: TitleMap.getString(result.PersonalDetails?.Title),
                    Gender: result.PersonalDetails?.Gender,
                    DateOfBirth: result.PersonalDetails?.DateOfBirth,
                },
            });
        });
    }

    onAdviserContextStoreChange(): void {
        this.loadAdviserFromStore();
    }

    getSecondCustomer(): void {
        const hierarchyId = getQueryParameters()["hierarchyid"];
        if (!CommonHelper.isNullOrEmpty(hierarchyId)) {
            AccountInfoAction.getAccountRoles(hierarchyId, (result) => {
                if (result.some((x) => x.Role == RoleType.JointAccountHolder)) {
                    const secondCustomerId = result.find(
                        (x) =>
                            x.Role == RoleType.JointAccountHolder &&
                            x.Customer?.CustomerId != this.props.customerId &&
                            x.Customer?.CustomerId > 0
                    )?.Customer?.CustomerId;
                    this.setState({ isJointAccount: true, secondCustomerId: secondCustomerId });
                    // read full client detail model for the second customer
                    if (secondCustomerId > 0) {this.loadSecondCustomer(secondCustomerId);}
                }
            });
        }
    }

    loadCustomerFromStore(): void {
        const val = CustomerContextStoreStatic.getData();
        if (
            val.CustomerTaxResidencyDetails.length > 1 &&
            val.CustomerTaxResidencyDetails[0].Country !== CountryCode.GBR
        ) {
            // Ensure UK is always at index 0 and always a tax resident
            const index = val.CustomerTaxResidencyDetails.findIndex((detail) => {
                return detail.Country === CountryCode.GBR;
            });
            const ukDetails = val.CustomerTaxResidencyDetails.splice(index, 1)[0];
            ukDetails.IsTaxResident = true;
            val.CustomerTaxResidencyDetails.unshift(ukDetails);
        }
        this.setState({
            model: val,
            isLoading: false,
            hasMobile: val.PhoneNumberDetails.some((ele) => ele.PhoneNumberType == CustomerPhoneNumberType.Mobile),
            hasLandPhone: val.PhoneNumberDetails.some((ele) => ele.PhoneNumberType == CustomerPhoneNumberType.Home),
        });

        if (val.GuardianId != null) {
            NewBusinessAction.getFullClientDetailsForTheSecondCustomer(val.GuardianId, (result) => {
                this.setState({
                    guardianmodel: result,
                    guardianHasLandPhone: result.PhoneNumberDetails.some(
                        (ele) => ele.PhoneNumberType == CustomerPhoneNumberType.Mobile
                    ),
                    guardianHasMobile: result.PhoneNumberDetails.some(
                        (ele) => ele.PhoneNumberType == CustomerPhoneNumberType.Home
                    ),
                });
                this.props.onChange({
                    GuardianClientDetails: {
                        ActorId: result.ActorId,
                        FirstName: result.PersonalDetails?.GivenName,
                        LastName: result.PersonalDetails?.FamilyName,
                        Title: TitleMap.getString(result.PersonalDetails?.Title),
                        Gender: result.PersonalDetails?.Gender,
                        DateOfBirth: result.PersonalDetails?.DateOfBirth,
                    },
                });
            })
        }
        
        const customer = CustomerContextStoreStatic.getData();
        this.props.onChange({
            ClientDetails: {
                ActorId: customer.ActorId,
                FirstName: customer.PersonalDetails?.GivenName,
                LastName: customer.PersonalDetails?.FamilyName,
                Title: TitleMap.getString(customer.PersonalDetails?.Title),
                Gender: customer.PersonalDetails?.Gender,
                DateOfBirth: customer.PersonalDetails?.DateOfBirth,
            },
        });
    }
    loadAdviserFromStore(): void {
        const adv = AdviserContextStoreStatic.getData();
        if (adv) {
            this.setState({
                AdvisorName: adv?.Name,
            });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        let customerId = this.props.customerId;
        const params = getQueryParameters();
        if (!CommonHelper.isNullOrEmpty(params["id"]) && CommonHelper.isNullOrEmpty(params["hierarychid"])) {
            customerId = this.props.data?.ClientDetails?.ActorId;
        }
        NewBusinessAction.getCustomerData(customerId, () => {
            this.getSecondCustomer();
        });
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        if (prevProps.customerId != this.props.customerId && prevProps.customerId != null) {
            NewBusinessAction.getCustomerData(this.props.customerId);
        }
    }

    isValid() {
        return (
            super.isValid() &&
            this.checkValidation(this.state.model) &&
            (!this.state.secondCustomerId || this.checkValidation(this.state.secondmodel)) &&
            (!this.state.model.GuardianId || this.checkValidation(this.state.guardianmodel))
        );
    }

    checkValidation(model: FullClientDetailModel) {
        const flag = super.isValid();
        let { isValid, errorMsg } = FullClientDetailHelper.fullClientDetailValidation(model);
        if (
            model?.AddressDetails?.find((ele) => ele.PhysicalAddressType == PhysicalAddressType.Residential)?.Address
                ?.Country != CountryCode.GBR
        ) {
            errorMsg = errorMsg.concat([
                "You must hold a UK Residential address in order to create a new account or sub-account.",
            ]);
            isValid = false;
        }
        if (
            !this.state.hasCorrespondenceAddress &&
            !model?.AddressDetails?.some((ele) => ele.PhysicalAddressType == PhysicalAddressType.Postal)
        ) {
            errorMsg = errorMsg.concat(["You must enter correspondence address"]);
            isValid = false;
        }
        if (errorMsg.length > 0) {
            this.props.showErrorMsgPopUp(errorMsg, true);
        }
        return flag && isValid;
    }

    saveBeforeExit(isExit: boolean) {
        this.saveCCMDetail(isExit, this.state.model, this.props.customerId);
        if (this.state.secondCustomerId) {
            this.saveCCMDetail(isExit, this.state.secondmodel, this.state.secondCustomerId);
        }
        else if (this.state.model.GuardianId > 0) {
            this.saveCCMDetail(isExit, this.state.guardianmodel, this.state.model.GuardianId);
        }
    }

    saveCCMDetail(isExit: boolean, model: FullClientDetailModel, customerId: number) {
        this.setState({ isBusy: true });
        const _model = FullClientDetailHelper.beforeSave(model);
        NewBusinessAction.saveCCMDetail(customerId, _model, () => {
            this.props.clearMsg();
            this.setState({ isBusy: false });
            CustomerContextDispatcher.dispatch({ actionType: ActionType.Success, payload: _model });
            if (this.props.navigateAfterSubmit) {
                if (isExit) {
                    Navigator.navigateTo(
                        Urls.get().main.PortfolioDashboard({
                            hierarchyId: HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, customerId),
                        }).activity
                    );
                } else {
                    Navigator.navigateToAndPreserveQueryParameters(Urls.get().WrapperSelection);
                }
            }
        });
    }

    private onCCMChange = (changes: { value: any; path: string }[], isSecondCustomer: boolean, isGuardianCustomer: boolean) => {
        let { model } = this.state;
        if (isSecondCustomer) {
            model = this.state.secondmodel;
        }
        if (isGuardianCustomer) {
            model = this.state.guardianmodel;
        }
        this.props.clearMsg();
        let _model = { ...model };
        changes.forEach((change) => {
            _model = setValueByKey(_model, change.path, change.value);
        });

        if (isSecondCustomer) {
            this.setState({ secondmodel: _model });
        } else if (isGuardianCustomer) {
            this.setState({ guardianmodel: _model });
        } else {
            this.setState({ model: _model });
        }
    };

    private renderGuardianDetails() {
        return (
            <>
                <CircleBtn
                    type={CircleBtnType.add}
                    title="Guardians Details"
                    onClick={() => this.setState({ addGuardianDetails: true })}
                />
            </>
        );
    }

    getFirstCustomerContent(): JSX.Element {
        return (
            <>
                <ClientDetail
                    data={this.state.model}
                    onChange={(changes) => {
                        this.props.onChange(changes);
                    }}
                    onCCMChange={(changes) => {
                        this.onCCMChange(changes, false, false);
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                    disableWhenFullClient={this.props.disableWhenFullClient}
                    existingClientInfo={this.state.model}
                    isAddNewProduct={this.props.isAddNewProduct}
                    index={1}
                />

                <ContactDetail
                    data={this.state.model}
                    onChange={(changes) => {
                        this.props.onChange(changes);
                    }}
                    onCCMChange={(changes) => {
                        this.onCCMChange(changes, false, false);
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                    disableWhenFullClient={this.props.disableWhenFullClient}
                    isAddNewProduct={this.props.isAddNewProduct}
                    onCorrespondenceAddressChange={(changes) => {
                        this.onCorrespondenceAddressChange(changes);
                    }}
                />

                <TaxDetail
                    data={this.state.model}
                    onChange={(changes) => {
                        this.props.onChange(changes);
                    }}
                    onCCMChange={(changes) => {
                        this.onCCMChange(changes, false, false);
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                    disableWhenFullClient={this.props.disableWhenFullClient}
                    isAddNewProduct={this.props.isAddNewProduct}
                    existingCustomer={this.props.existingCustomer}
                />
                
                {this.state.model.GuardianId && this.state.addGuardianDetails && (
                    <>
                        <div>
                            <CircleBtn
                                type={CircleBtnType.remove}
                                title="Guardians Details"
                                onClick={() => this.setState({ addGuardianDetails: false })}
                            />
                        </div>
                        <GuardianDetail
                            data={this.state.guardianmodel}
                            onChange={(changes) => {
                                this.props.onChange(changes);
                            }}
                            onCCMChange={(changes) => {
                                this.onCCMChange(changes, false, true);
                            }}
                            onRef={(ref) => this.appendChild(ref)}
                            disableWhenFullClient={this.props.disableWhenFullClient}
                            isAddNewProduct={this.props.isAddNewProduct}
                            index={3}
                        />
                        
                        <ContactDetail
                            data={this.state.guardianmodel}
                            onChange={(changes) => {
                                this.props.onChange(changes);
                            }}
                            onCCMChange={(changes) => {
                                this.onCCMChange(changes, false, true);
                            }}
                            onRef={(ref) => this.appendChild(ref)}
                            disableWhenFullClient={this.props.disableWhenFullClient}
                            isAddNewProduct={this.props.isAddNewProduct}
                            onCorrespondenceAddressChange={(changes) => {
                                this.onCorrespondenceAddressChange(changes);
                            }}
                        />

                        <TaxDetail
                            data={this.state.guardianmodel}
                            onChange={(changes) => {
                                this.props.onChange(changes);
                            }}
                            onCCMChange={(changes) => {
                                this.onCCMChange(changes, false, true);
                            }}
                            onRef={(ref) => this.appendChild(ref)}
                            disableWhenFullClient={this.props.disableWhenFullClient}
                            isAddNewProduct={this.props.isAddNewProduct}
                            existingCustomer={this.props.existingCustomer}
                        />
                    </>
                )}
                
                {!this.state.addGuardianDetails && this.renderGuardianDetails()}
            </>
        );
    }

    getSecondCustomerContent(): JSX.Element {
        return (
            <>
                <ClientDetail
                    data={this.state.secondmodel}
                    onChange={(changes) => {
                        this.props.onChange(changes);
                    }}
                    onCCMChange={(changes) => {
                        this.onCCMChange(changes, true, false);
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                    disableWhenFullClient={this.props.disableWhenFullClient}
                    isAddNewProduct={this.props.isAddNewProduct}
                    existingClientInfo={this.state.secondmodel}
                    index={2}
                />
                <ContactDetail
                    data={this.state.secondmodel}
                    onChange={(changes) => {
                        this.props.onChange(changes);
                    }}
                    onCCMChange={(changes) => {
                        this.onCCMChange(changes, true, false);
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                    disableWhenFullClient={this.props.disableWhenFullClient}
                    isAddNewProduct={this.props.isAddNewProduct}
                    onCorrespondenceAddressChange={(changes) => {
                        this.onCorrespondenceAddressChange(changes);
                    }}
                />
                <TaxDetail
                    data={this.state.secondmodel}
                    onChange={(changes) => {
                        this.props.onChange(changes);
                    }}
                    onCCMChange={(changes) => {
                        this.onCCMChange(changes, true, false);
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                    disableWhenFullClient={this.props.disableWhenFullClient}
                    isAddNewProduct={this.props.isAddNewProduct}
                    existingCustomer={this.props.existingCustomer}
                />
            </>
        );
    }
    render() {
        if (this.state.isLoading) {
            return <PartLoading />;
        }
        return (
            <>
                <h2>{NBSteppers.fullClientDetail}</h2>
                <AdviserDetail
                    data={this.state.AdvisorName}
                    onChange={() => {}}
                    onAdviserChange={null}
                    onRef={(ref) => this.appendChild(ref)}
                />
                {!this.state.secondCustomerId || this.state.secondCustomerId == 0 ? (
                    this.getFirstCustomerContent()
                ) : (
                    <>
                        <Accordion label={""} cssWrapper="accordion-total-clients" isOpen={true}>
                            {this.getFirstCustomerContent()}
                        </Accordion>
                    </>
                )}

                {this.props.navigateAfterSubmit && (
                    <ProcessNavigateCustomBtn
                        primary={{
                            title: "Next",
                            onClick: () => {
                                if (
                                    this.checkValidation(this.state.model) &&
                                    (!this.state.secondCustomerId ||
                                        this.state.secondCustomerId == 0 ||
                                        this.checkValidation(this.state.secondmodel)) && (!this.state.model.GuardianId || this.checkValidation(this.state.guardianmodel))
                                ) {
                                    let customerId = this.props.customerId;
                                    const params = getQueryParameters();
                                    if (
                                        !CommonHelper.isNullOrEmpty(params["id"]) &&
                                        CommonHelper.isNullOrEmpty(params["hierarychid"])
                                    ) {
                                        customerId = this.props.data?.ClientDetails?.ActorId;
                                    }
                                    this.saveCCMDetail(false, this.state.model, customerId);
                                    if (this.state.secondCustomerId > 0) {
                                        this.saveCCMDetail(false, this.state.secondmodel, this.state.secondCustomerId);
                                    }
                                    else if (this.state.model.GuardianId > 0) {
                                        this.saveCCMDetail(false, this.state.guardianmodel, this.state.model.GuardianId);
                                    }
                                }
                            },
                        }}
                        isBusy={this.state.isBusy}
                    />
                )}
            </>
        );
    }
}
